import * as React from "react";
import { SVGProps } from "react";
const SvgOpenMaximize = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 15h-9V6c0-.6-.4-1-1-1s-1 .4-1 1v9H6c-.6 0-1 .4-1 1s.4 1 1 1h9v9c0 .6.4 1 1 1s1-.4 1-1v-9h9c.6 0 1-.4 1-1s-.4-1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOpenMaximize;
